// src/plugins/fontAwesomeIcons.ts
import { library, dom } from "@fortawesome/fontawesome-svg-core"

// import { all } from "@awesome.me/kit-82a6b154a9/icons"

// Import specific icons from your Kit
import {
  faA,
  faAddressBook,
  faAlarmClock,
  faAlarmExclamation,
  faAlarmSnooze,
  faAlbumCollection,
  faArchive,
  faArrowDown,
  faArrowDownAZ,
  faArrowDownWideShort,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowUpZA,
  faArrowsCross,
  faAsterisk,
  faB,
  faBan,
  faBank,
  faBed,
  faBarProgressFull as faBarProgressFullLight,
  faBars as faBarsLight,
  faBell,
  faBellExclamation,
  faBinRecycle,
  faBoltLightning as faBoltLightningLight,
  faBook,
  faBookmark,
  faBooks,
  faBoxOpen,
  faBriefcase,
  faBrowser,
  faBug,
  faBuilding,
  faC,
  faCalculator,
  faCalendar,
  faCalendarCheck,
  faCalendarCircleExclamation,
  faCalendarPlus,
  faCalendarRange,
  faCalendarStar,
  faCamera,
  faCartPlus,
  faCaretDown as faCaretDownLight,
  faCaretUp,
  faCertificate as faCertificateLight,
  faChain,
  faChartBar,
  faChartNetwork,
  faChartPieSimple,
  faChartWaterfall,
  faCheck as faCheckLight,
  faCheckCircle as faCheckCircleLight,
  faCheckDouble,
  faCheckSquare,
  faChevronDown,
  faChevronLeft as faChevronLeftLight,
  faChevronRight,
  faChevronUp,
  faCircle as faCircleLight,
  faCircleHalfStroke,
  faCircleArrowDown,
  faCircleExclamation,
  faCircleDollar,
  faCircleEnvelope,
  faCircleNotch,
  faClipboardCheck as faClipboardCheckLight,
  faClipboardListCheck,
  faClipboardQuestion,
  faClipboardUser,
  faClock as faClockLight,
  faCloudArrowUp,
  faCloudCheck,
  faCloudDownload,
  faCloudQuestion,
  faCloudUpload,
  faCode,
  faCoins,
  faCommentDollar,
  faCommentDots,
  faCompressAlt,
  faCopy,
  faCreditCard as faCreditCardLight,
  faCube,
  faCut as faCutLight,
  faD,
  faDatabase,
  faDollar,
  faDollarCircle,
  faDollarSign as faDollarSignLight,
  faDollarSquare,
  faDownload,
  faE,
  faEdit,
  faEnvelope as faEnvelopeLight,
  faEnvelopeOpen,
  faEnvelopesBulk,
  faExchangeAlt,
  faExpandAlt,
  faExclamationTriangle,
  faExternalLink as faExternalLinkLight,
  faExternalLinkAlt,
  faEye as faEyeLight,
  faEyeSlash,
  faF,
  faFaceDisappointed,
  faFaceDisguise,
  faFaceDotted,
  faFacePleading,
  faFaceSadTear,
  faFaceSmileWink,
  faFastBackward as faFastBackwardLight,
  faFax,
  faFile,
  faFileArrowDown,
  faFileCheck,
  faFileCode,
  faFileCsv,
  faFileEdit,
  faFileExcel,
  faFileExclamation,
  faFileImage,
  faFileImport,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileMagnifyingGlass,
  faFileMusic,
  faFilePdf,
  faFilePowerpoint,
  faFileSignature,
  faFileWord as faFileWordLight,
  faFileZipper,
  faFiles,
  faFilter,
  faFlag as faFlagLight,
  faFlagCheckered,
  faFolder,
  faFolders,
  faFolderGrid,
  faFolderOpen as faFolderOpenLight,
  faFolderPlus,
  faFontCase,
  faFrown,
  faG,
  faGiftCard,
  faGlasses,
  faGavel,
  faGlobe as faGlobeLight,
  faGlobeAmericas,
  faGlobeEurope,
  faGolfFlagHole,
  faGraduationCap,
  faGrid,
  faH,
  faHand,
  faHandHoldingUsd,
  faHandPointUp,
  faHandshake,
  faHandWave,
  faHeadset,
  faHeadSide,
  faHexagonCheck,
  faHistory,
  faHospital,
  faHouse,
  faHourglassHalf,
  faHundredPoints,
  faI,
  faIdCard,
  faIdCardClip,
  faIdBadge,
  faLifeRing,
  faComments,
  faImage,
  faInbox,
  faInboxArrowDown,
  faInboxIn,
  faInfinity as faInfinityLight,
  faInfoCircle,
  faJ,
  faK,
  faL,
  faLandmark,
  faLanguage,
  faHammer,
  faLayerPlus,
  faLightbulb,
  faLink,
  faList,
  faLock as faLockLight,
  faLockOpen,
  faM,
  faMagicWandSparkles,
  faMailBulk,
  faMailbox,
  faMailboxFlagUp,
  faMemoCircleCheck,
  faMoped,
  faMoonStar,
  faMinus as faMinusLight,
  faMobileScreenButton,
  faMobileAlt,
  faMoneyBillAlt,
  faMoneyCheck,
  faMoneyCheckAlt,
  faMoneyCheckDollar,
  faMugHot,
  faN,
  faNewspaper,
  faNotes,
  faO,
  faP,
  faPalette,
  faPartyHorn,
  faPaperPlane as faPaperPlaneLight,
  faPaperclip,
  faPaste,
  faPen,
  faPenSquare as faPenSquareLight,
  faPencil,
  faPhone as faPhoneLight,
  faPiggyBank,
  faPlane,
  faPlus as faPlusLight,
  faPlusCircle,
  faPlusSquare,
  faPowerOff,
  faPrint,
  faPrintSearch,
  faQ,
  faQuestion,
  faR as faRLight,
  faReceipt,
  faRefresh as faRefreshLight,
  faRobot as faRobotLight,
  faRocket,
  faRotateLeft,
  faS as faSLight,
  faSackDollar,
  faSave,
  faScannerImage,
  faSearch as faSearchLight,
  faShippingFast,
  faSignature,
  faSignIn,
  faSmile,
  faSortAmountDown,
  faSortAmountUp,
  faSparkles,
  faSpinner,
  faSquareDollar,
  faStamp,
  faStar as faStarLight,
  faSun as faSunLight,
  faSunBright,
  faSunDust,
  faT,
  faTachometer,
  faTally,
  faTasks,
  faTerminal,
  faTrademark,
  faThumbsUp,
  faTimer,
  faTimes as faTimesLight,
  faTimesCircle,
  faTransporterEmpty,
  faTrash,
  faTrashAlt,
  faTrashCanPlus,
  faTrashList,
  faTrashSlash,
  faTrashUndo,
  faTriangleExclamation,
  faTruck,
  faTruckBolt,
  faTruckFast as faTruckFastLight,
  faTypewriter as faTypewriterLight,
  faU,
  faUndo,
  faUmbrella,
  faUmbrellaBeach,
  faUniversity,
  faUpload,
  faUser,
  faUserCircle,
  faUserGroupSimple,
  faUserCog,
  faUserPlus,
  faUserSlash,
  faUsers,
  faUsersGear,
  faUsersRectangle,
  faKey,
  faV,
  faW,
  faWallet,
  faWarning,
  faWindowFrame,
  faX,
  faY,
  faZ,
} from "@awesome.me/kit-82a6b154a9/icons/classic/light"
import {
  faLanguage as faLanguageSolid,
  faThumbsUp as faThumbsUpSolid,
  faFolderOpen as faFolderOpenSolid,
  faBarProgressFull as faBarProgressFullSolid,
  faCaretDown as faCaretDownSolid,
  faClipboardCheck as faClipboardCheckSolid,
  faClock as faClockSolid,
  faTruckFast as faTruckFastSolid,
  faBoltLightning as faBoltLightningSolid,
  faCheck as faCheckSolid,
  faCheckCircle as faCheckCircleSolid,
  faCertificate as faCertificateSolid,
  faSearch as faSearchSolid,
  faExternalLink as faExternalLinkSolid,
  faDollarSign as faDollarSignSolid,
  faEnvelope as faEnvelopeSolid,
  faEye as faEyeSolid,
  faBars as faBarsSolid,
  faGlobe as faGlobeSolid,
  faInfinity as faInfinitySolid,
  faTimes as faTimesSolid,
  faRefresh as faRefreshSolid,
  faPaperPlane as faPaperPlaneSolid,
  faSun as faSunSolid,
  faMoon as faMoonSolid,
  faRobot as faRobotSolid,
  faTypewriter as faTypewriterSolid,
  faFileWord as faFileWordSolid,
  faPenSquare as faPenSquareSolid,
  faCut as faCutSolid,
  faPhone as faPhoneSolid,
  faCreditCard as faCreditCardSolid,
  faPlus as faPlusSolid,
  faFastBackward as faFastBackwardSolid,
  faChevronLeft as faChevronLeftSolid,
  faCircle3,
  faStar as faStarSolid,
  faFlag as faFlagSolid,
  faCircle as faCircleSolid,
  faQuestionCircle,
  faMinus as faMinusSolid,
  faLock as faLockSolid,
  faS as faSSolid,
  faR as faRSolid,
} from "@awesome.me/kit-82a6b154a9/icons/classic/solid"

import { faBabbleon, faBabbleonAlt } from "@awesome.me/kit-82a6b154a9/icons/kit/custom"

import {
  faAlipay,
  faAppStoreIos,
  faApplePay,
  faCcAmex,
  faCcDinersClub,
  faCcDiscover,
  faCcJcb,
  faCcMastercard,
  faCcStripe,
  faCcVisa,
  faGooglePay,
  faPaypal,
  faWeibo,
  faGithub,
  faBitbucket,
  faAndroid,
  faJira,
} from "@awesome.me/kit-82a6b154a9/icons/classic/brands"

// Add all icons to the library
library.add(
  faA,
  faAddressBook,
  faAlarmClock,
  faAlarmExclamation,
  faAlarmSnooze,
  faAlbumCollection,
  faArchive,
  faArrowDown,
  faArrowDownAZ,
  faArrowDownWideShort,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowUpZA,
  faArrowsCross,
  faAsterisk,
  faB,
  faBan,
  faBank,
  faBed,
  faBarProgressFullLight,
  faBarProgressFullSolid,
  faBarsLight,
  faBarsSolid,
  faBell,
  faBellExclamation,
  faBinRecycle,
  faBoltLightningLight,
  faBoltLightningSolid,
  faBook,
  faBookmark,
  faBooks,
  faBoxOpen,
  faBriefcase,
  faBrowser,
  faBug,
  faBuilding,
  faC,
  faCalculator,
  faCalendar,
  faCalendarCheck,
  faCalendarCircleExclamation,
  faCalendarPlus,
  faCalendarRange,
  faCalendarStar,
  faCamera,
  faCartPlus,
  faCaretDownLight,
  faCaretDownSolid,
  faCaretUp,
  faCertificateLight,
  faCertificateSolid,
  faChain,
  faChartBar,
  faChartNetwork,
  faChartPieSimple,
  faChartWaterfall,
  faCheckDouble,
  faCheckLight,
  faCheckSolid,
  faCheckCircleLight,
  faCheckCircleSolid,
  faCheckSquare,
  faChevronDown,
  faChevronLeftLight,
  faChevronLeftSolid,
  faChevronRight,
  faChevronUp,
  faCircleArrowDown,
  faCircleExclamation,
  faCircleLight,
  faCircleSolid,
  faCircle3,
  faCircleDollar,
  faCircleEnvelope,
  faCircleNotch,
  faClipboardCheckSolid,
  faClipboardCheckLight,
  faClipboardListCheck,
  faClipboardQuestion,
  faClipboardUser,
  faClockLight,
  faClockSolid,
  faCloudArrowUp,
  faCloudCheck,
  faCloudDownload,
  faCloudQuestion,
  faCloudUpload,
  faCode,
  faCoins,
  faCommentDollar,
  faCommentDots,
  faCompressAlt,
  faCopy,
  faCreditCardLight,
  faCreditCardSolid,
  faCube,
  faCutLight,
  faCutSolid,
  faD,
  faDatabase,
  faDollar,
  faDollarCircle,
  faDollarSignLight,
  faDollarSignSolid,
  faDollarSquare,
  faDownload,
  faE,
  faEdit,
  faEnvelopeLight,
  faEnvelopeSolid,
  faEnvelopeOpen,
  faEnvelopesBulk,
  faExchangeAlt,
  faExpandAlt,
  faExclamationTriangle,
  faExternalLinkLight,
  faExternalLinkSolid,
  faExternalLinkAlt,
  faEyeLight,
  faEyeSolid,
  faEyeSlash,
  faF,
  faFaceDisappointed,
  faFaceDisguise,
  faFaceDotted,
  faFacePleading,
  faFaceSadTear,
  faFaceSmileWink,
  faFastBackwardLight,
  faFastBackwardSolid,
  faFax,
  faFile,
  faFileArrowDown,
  faFileCheck,
  faFileCode,
  faFileCsv,
  faFileEdit,
  faFileExcel,
  faFileExclamation,
  faFileImage,
  faFileImport,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileMagnifyingGlass,
  faFileMusic,
  faFilePdf,
  faFilePowerpoint,
  faFileSignature,
  faFileWordLight,
  faFileWordSolid,
  faFileZipper,
  faFiles,
  faFilter,
  faFlagLight,
  faFlagSolid,
  faFlagCheckered,
  faFolder,
  faFolders,
  faFolderGrid,
  faFolderOpenLight,
  faFolderOpenSolid,
  faFolderPlus,
  faFontCase,
  faFrown,
  faG,
  faGiftCard,
  faGlasses,
  faGavel,
  faGlobeLight,
  faGlobeSolid,
  faGlobeAmericas,
  faGlobeEurope,
  faGolfFlagHole,
  faGraduationCap,
  faGrid,
  faH,
  faHand,
  faHandHoldingUsd,
  faHandPointUp,
  faHandshake,
  faHandWave,
  faHeadset,
  faHeadSide,
  faHexagonCheck,
  faHistory,
  faHospital,
  faHouse,
  faHourglassHalf,
  faHundredPoints,
  faI,
  faIdCard,
  faIdBadge,
  faIdCardClip,
  faLifeRing,
  faComments,
  faImage,
  faInbox,
  faInboxArrowDown,
  faInboxIn,
  faInfinityLight,
  faInfinitySolid,
  faInfoCircle,
  faJ,
  faK,
  faL,
  faLandmark,
  faLanguage,
  faHammer,
  faLanguageSolid,
  faThumbsUpSolid,
  faLayerPlus,
  faLightbulb,
  faLink,
  faList,
  faLockLight,
  faLockSolid,
  faLockOpen,
  faM,
  faMagicWandSparkles,
  faMailBulk,
  faMailbox,
  faMailboxFlagUp,
  faMemoCircleCheck,
  faMinusLight,
  faMinusSolid,
  faMobileScreenButton,
  faMobileAlt,
  faMoped,
  faMoneyBillAlt,
  faMoneyCheck,
  faMoneyCheckAlt,
  faMoneyCheckDollar,
  faMoonStar,
  faCircleHalfStroke,
  faMugHot,
  faN,
  faNewspaper,
  faNotes,
  faO,
  faP,
  faPalette,
  faPartyHorn,
  faPaperPlaneLight,
  faPaperPlaneSolid,
  faPaperclip,
  faPaste,
  faPen,
  faPenSquareLight,
  faPenSquareSolid,
  faPencil,
  faPhoneLight,
  faPhoneSolid,
  faPiggyBank,
  faPlane,
  faPlusLight,
  faPlusCircle,
  faPlusSolid,
  faPlusSquare,
  faPowerOff,
  faPrint,
  faPrintSearch,
  faQ,
  faQuestion,
  faQuestionCircle,
  faRLight,
  faRSolid,
  faReceipt,
  faRefreshLight,
  faRefreshSolid,
  faRobotLight,
  faRobotSolid,
  faRocket,
  faRotateLeft,
  faSLight,
  faSSolid,
  faSackDollar,
  faSave,
  faScannerImage,
  faSearchLight,
  faSearchSolid,
  faShippingFast,
  faSignature,
  faSignIn,
  faSmile,
  faSortAmountDown,
  faSortAmountUp,
  faSparkles,
  faSpinner,
  faSquareDollar,
  faStamp,
  faStarLight,
  faStarSolid,
  faSunLight,
  faSunSolid,
  faMoonSolid,
  faSunBright,
  faSunDust,
  faT,
  faTachometer,
  faTally,
  faTasks,
  faTerminal,
  faTrademark,
  faThumbsUp,
  faTimer,
  faTimesLight,
  faTimesSolid,
  faTimesCircle,
  faTransporterEmpty,
  faTrash,
  faTrashAlt,
  faTrashCanPlus,
  faTrashList,
  faTrashSlash,
  faTrashUndo,
  faTriangleExclamation,
  faTruck,
  faTruckBolt,
  faTruckFastLight,
  faTruckFastSolid,
  faTypewriterLight,
  faTypewriterSolid,
  faU,
  faUndo,
  faUmbrella,
  faUmbrellaBeach,
  faUniversity,
  faUpload,
  faUser,
  faUserCircle,
  faUserCog,
  faUserGroupSimple,
  faUserPlus,
  faUserSlash,
  faUsers,
  faUsersGear,
  faUsersRectangle,
  faKey,
  faV,
  faW,
  faWallet,
  faWarning,
  faWindowFrame,
  faX,
  faY,
  faZ,
  faAlipay,
  faAppStoreIos,
  faApplePay,
  faCcAmex,
  faCcDinersClub,
  faCcDiscover,
  faCcJcb,
  faCcMastercard,
  faCcStripe,
  faCcVisa,
  faGooglePay,
  faPaypal,
  faWeibo,
  faGithub,
  faBitbucket,
  faAndroid,
  faJira,
  faBabbleon,
  faBabbleonAlt
)

// Watch the DOM for changes (if you use class-based icon syntax).
// Skip when embedded as a standalone widget — the host page manages its own FA icons.
if (!document.getElementById("glossary-app")) {
  dom.watch()
}
